import { useState, useEffect, useCallback } from 'react';
import { listPlaces } from '../services/api';
import type { Place } from '../types';

export function usePlaces() {
  const [places, setPlaces] = useState<Place[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchPlaces = useCallback(() => {
    setLoading(true);
    listPlaces()
      .then(setPlaces)
      .catch((err: Error & { status?: number }) => {
        if (err.status !== 401) setError(err.message);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    fetchPlaces();
  }, [fetchPlaces]);

  return { places, loading, error, refetch: fetchPlaces };
}
